export const NewIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="24" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M24 14V24L30 27"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="24"
      cy="24"
      r="10"
      stroke="currentColor"
      strokeWidth="2.5"
      fill="none"
    />
  </svg>
);
